export default "images/logoIcon.png";